import { createSelector } from 'reselect';
import { AppState } from '../store/app-state';

export const dffState = (state: AppState) => state.dff;
export const mount = createSelector(dffState, state => state.mount);
export const user = createSelector(dffState, state => state.user);
export const baseUrl = createSelector(dffState, state => state.baseUrl);
